import { Component } from 'react'
import Input from '~/components/OrdersPage/Input'
import Points from '~/utils/Points'
import styles from '~/styles/ordersPage.customerProperties.module.css'
import types from '~/types/ordersPage.ts'
import PhoneInput from 'react-phone-input-2'
import Measurements from '~/utils/Measurements'
import 'react-phone-input-2/lib/style.css'

export default class CustomerProperties extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
			
		}
	}
	
	constructor(props) {
		super(props)
		let customerAddress = this.props.order.customer_address?.full_address
		if (!customerAddress) {
		    customerAddress = this.props.order.manuallyEnteredCustomerAddress
		}
		if (!customerAddress) {
			const pointDescription = this.props.order.pointDescription || this.props.order.point_description
		    if (this.props.order.pointAddress && pointDescription) {
		      	customerAddress = this.props.order.pointAddress + ', ' + pointDescription
		    }
		}
		this.state = {
			customerAddress,
			isPhoneChanged: false,
		}
	}
	
	render(): JSX.Element {
		let dealerCountry = (this.props.currentDealer?.dealer_country || '').toLowerCase()
		let phonePlaceholder = '+1 999 999-9999'
		if (this.props.isRu || dealerCountry == 'ru') {
			phonePlaceholder = '+7 (999) 999-99-99'
		} else if (this.props.isGb || dealerCountry == 'gb') {
			phonePlaceholder = '+7 999 99999999'
		}
		let phonePattern = "\\+1 [0-9]{3} [0-9]{3}-[0-9]{4}"
		if (this.props.isRu) {
			phonePattern = "\\+7 ([0-9]{3}) [0-9]{3}-[0-9]{2}-[0-9]{2}"
		} else if (this.props.isGb || dealerCountry == 'gb') {
			phonePattern = "\\+44 [0-9]{3} [0-9]{7,8}"
		}
		return (
			<div
				className={styles.main}
			>
				<div
					className={styles.firstLine}
				>
					<Input
						type="email"
						name="email"
						label={this.props.t('in_cust_email_label')}
						initial={this.props.order?.in_cust_email || ''}
						placeholder="customer@email.com"
						isRequiredFunction={this._getRequiredFunction('in_cust_email')}
						isRequiredSignInside="true"
						onChange={this.props.editTheOrder.bind(this, 'in_cust_email')}
						t={this.props.t}
					/>
					<div
						className={styles.phone}
					>
						<label>
							{this.props.t('in_cust_phone_label')}
						</label>
						<div>
							<PhoneInput
							  country={dealerCountry}
							  value={this.props.order?.in_cust_phone || ''}
							  onChange={this._onPhoneChange.bind(this)}
							  preferredCountries={["us", "ca", "gb", "fr", "ru"]}
							  inputProps={{ name: 'phone' }}
							  masks={{
								ru: '(...) ...-..-..', 
								gb: '... ....-....',
								us: '... ...-....'
							  }}
							/>
						</div>
						<div
							className={this._isRequiredPhone() ? styles.phoneIsRequired : styles.hidden}
						>
							{this.props.t('common:Required')}
						</div>
					</div>
					<Input
						type="text"
						name="name"
						label={this.props.t('in_cust_name_label')}
						initial={this.props.order?.in_cust_name || ''}
						placeholder={this.props.t('in_cust_name_placeholder')}
						isRequiredFunction={this._getRequiredFunction('in_cust_name')}
						isRequiredSignInside="true"
						onChange={this.props.editTheOrder.bind(this, 'in_cust_name')}
						t={this.props.t}
					/>
				</div>
				<div
					className={styles.secondLine}
				>
					<div>
						<label>
							{this._getAddressLabel()}
						</label>
						<div>
							<Input
								type="text"
								name="address"
								value={this.state.customerAddress || ''}
								placeholder={this.props.t('Full Address Placeholder')}
								isRequiredFunction={this._getRequiredFunction('manuallyEnteredCustomerAddress')}
								isRequiredSignInside="true"
								onChange={this._onCustomerAddressChange.bind(this, null)}
								t={this.props.t}
							/>
							<div
								className={styles.button}
								onClick={this._onCheckOnMap.bind(this)}
							>
								{this.props.t('Check on Map')}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	private _getAddressLabel() {
		const string = this.props.t('Full Address')
		let label = []
		const parts = string.split("'")
		parts.forEach((part, i) => {
			if (i && part.length > 2) {
				label.push((
					<span
						key={i}
						className={styles.addressExample}
						onClick={this._onLabelClick.bind(this, part)}
					>
						'{part}'
					</span>
				))
			} else {
				label.push((
					<span
						key={i}
					>
						{part}
					</span>
				))
			}
		})
		return label
	}

	private _onLabelClick(part) {
		this._onCustomerAddressChange(null, part)
	}
	
	private _getRequiredFunction(key: string) {
		let value = this.props.order?.[key]
		if (key === 'manuallyEnteredCustomerAddress' && !value) {
			value = this.state.customerAddress
		}
		return () => !((value || '').length > 0)
	}
	
	private _isRequiredPhone() {
		const phone = this.props.order?.in_cust_phone || ''
		const isRequiredPhone = !((phone + '').replace(/[^0-9]+/g, '').length >= 11)
		return isRequiredPhone
	}

	private _onPhoneChange(phone): void {
		if (!this.state.isPhoneChanged) {
			if (this.props.currentDealer?.dealer_country === 'US') {
				if (phone?.length === 10) {
					phone = 1 + phone
				}	
			} else if (this.props.currentDealer?.dealer_country === 'GB') {
				if (phone?.length === 10) {
					phone = 44 + phone
				}	
			}
		}
		this.props.editTheOrder('in_cust_phone', phone)
		this.setState({ isPhoneChanged: true })
	}
	
	private _getPhoneNumber(): string {
		let phoneToBecomePattern4 = '+$1 $2'
		let phoneToBecomePattern7 = '+$1 $2 $3'
		let phoneToBecomePattern10 = '+$1 $2 $3-$4'
		let phoneToBecomePattern11 = '+$1 $2 $3-$4'
		if (this.props.isRu) {
			phoneToBecomePattern4 = '+$1 ($2)'
			phoneToBecomePattern7 = '+$1 ($2) $3'
			phoneToBecomePattern10 = '+$1 ($2) $3-$4'
			phoneToBecomePattern11 = '+$1 ($2) $3-$4-$5'
		}
		let phoneDigits = (this.props.order?.in_cust_phone + '' || '').replace(/[^0-9]/g, '')
		let phoneRegExp4 = /^([0-9]{1})([0-9]+)$/
		let phoneRegExp7 = /^([0-9]{1})([0-9]{3})([0-9]+)$/
		let phoneRegExp10 = /^([0-9]{1})([0-9]{3})([0-9]{3})([0-9]+)$/
		let phoneRegExp11 = /^([0-9]+)([0-9]{3})([0-9]{3})([0-9]{4})$/
		if (this.props.isRu) {
			phoneRegExp11 = /^([0-9]+)([0-9]{3})([0-9]{3})([0-9]{2})([0-9]{2})$/
		}
		let phoneNumber = phoneDigits.replace(phoneRegExp11, phoneToBecomePattern11)
		if ((phoneDigits+ '').length === 1) {
			phoneNumber = '+1'
			if (this.props.isRu) {
				phoneNumber = '+7'
			}
		} else if ((phoneDigits+ '').length <= 4) {
			phoneNumber = phoneDigits.replace(phoneRegExp4, phoneToBecomePattern4)
			if ((phoneNumber + '').endsWith(')')) {
				phoneNumber = (phoneNumber + '').replace(')', '')
			}
		} else if ((phoneDigits+ '').length <= 7) {
			phoneNumber = phoneDigits.replace(phoneRegExp7, phoneToBecomePattern7)
		} else if ((phoneDigits+ '').length <= 10) {
			phoneNumber = phoneDigits.replace(phoneRegExp10, phoneToBecomePattern10)
		}
		return phoneNumber
	}
	
	private _onCustomerAddressChange(event, value?: string): void {
		if (!value) {
			value = event?.target?.value
		}
		if (value?.length > 2) {
			this.props.setPointsLoading(true)
		}
		this.setState({ customerAddress: value })
		if (this._onPointsST) {
			clearTimeout(this._onPointsST)
		}
		this._onPointsST = setTimeout(async () => {
			if (value?.length > 2) {
				this.props.chargeableWeightUpdater()
			}
			if (!value) {
				this.props.setPointsLoading(false)
				this.props?.editTheOrder('manuallyEnteredCustomerAddress', '')
			} else {
				if (value?.length > 2) {
					const points = new Points({
						order: this.props.order,
						choosePointType: 'customerAddressInput',
						isRu: this.props.isRu,
					})
					const newData = await points.getNearestPoints(value || '')
					if (newData) {
						const dimensionalMU = this.props.order.dealer_dimensions_mu
						const weightMU = this.props.order.dealer_weight_mu
						const measurements = new Measurements(dimensionalMU, weightMU)
						const { muLength, muWidth, muHeight, muWeight } = measurements.getByOrder(this.props.order)
						const sameTotal = (newData.totalPrice === this.props.order.in_total)
						const sameLength = (newData.muLength === muLength)
						const sameWidth = (newData.muWidth === muWidth)
						const sameHeight = (newData.muHeight === muHeight)
						if (sameTotal && sameLength && sameWidth && sameHeight) {
							if (newData?.points?.length) {
								newData.noPoints = false
							} else {
								newData.noPoints = true
							}
							this.props?.editTheOrder(newData)
							setTimeout(() => {
								this.props.chargeableWeightUpdater()
								this.props.setPointsLoading(false)
							})
						} else {
							setTimeout(() => {
								this.props.setPointsLoading(false)
							}, 1000)
						}
					} else {
						this.props.setPointsLoading(false)
					}
				}
			}
		}, 600)
	}
	
	private _onCheckOnMap(): void {
		this.props.showMap(null, 'customerAddressCheckOnMap')
	}
}